import { Eye } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from './ui'

interface Props {
  children: ReactNode
  wide?: boolean
  /** When given, a "Look at the board" link lets the player hide the card to review the position. */
  onPeek?: () => void
  /** Match the board's corners: the Light Cycles arena is square-edged. */
  shape?: 'rounded' | 'square'
}

/** Dimmed layer over a game board with a centered card (results, lobby notice, level clear). */
export function BoardOverlay({ children, wide = false, onPeek, shape = 'rounded' }: Props) {
  return (
    <div
      className={`absolute inset-0 z-10 flex items-center justify-center bg-slate-900/60 p-3 backdrop-blur-[2px] ${shape === 'rounded' ? 'rounded-3xl' : ''}`}
    >
      <div
        className={`max-h-full w-full overflow-y-auto rounded-2xl bg-white p-4 text-center shadow-xl dark:bg-slate-900 ${wide ? 'max-w-sm' : 'max-w-xs p-5'}`}
      >
        {children}
        {onPeek && (
          <Button variant="ghost" className="mt-2 w-full text-slate-500" onClick={onPeek}>
            <Eye className="size-4" aria-hidden /> Look at the board
          </Button>
        )}
      </div>
    </div>
  )
}
